<template>
  <div class="message">
    <message-transition>
      <div v-for="(message, index) in messages" :key="index" class="message-item">
        <message :message="message" @close="handleClose" />
      </div>
    </message-transition>
  </div>
</template>

<script>
import Message from '@/components/Modals/Message';
import { MessageTransition } from './config';
import { mapState, mapActions } from 'vuex';

export default {
  created() {},
  methods: {
    ...mapActions('UI', ['REMOVE_MESSAGE']),
    handleClose(message) {
      this.REMOVE_MESSAGE(message.id);
    },
  },
  components: {
    Message,
    MessageTransition,
  },
  computed: {
    ...mapState('UI', ['messages']),
  },
};
</script>

<style lang="scss">
@keyframes fallDown10 {
  from {
    transform: translateY(-10px);
  }
  to {
    transform: none;
  }
}

.message {
  z-index: 1000;
  position: absolute;
  width: 100%;

  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &-enter-active {
    transition: opacity 0.2s;
    animation: fallDown10 0.2s;
  }

  &-leave-active {
    transition: opacity 0.2s;
    animation: fallDown10 0.2s reverse;
  }
}
</style>
